import { chatRoomApi } from '../api/chat-room'

export const {
  useGetChatRoomQuery,
  useSendChatMessageMutation,
  useMarkMessageAsReadMutation,
  useConfirmReadingMessagesMutation,
  useSendGlobalMessageMutation,
  useCreateChatRoomMutation,
  useGetChatRoomsJoinedByUserQuery,
  useGetChatRoomMessagesQuery,
  useLazyGetChatRoomMessagesQuery,
} = chatRoomApi
